<template>
  <div class="">
    <swiper
      dots-position="center"
      :auto="true"
      style="height: 4rem !important;"
    >
      <swiper-item
        class="swiper-demo-img"
        v-for="(item, index) in bannerList"
        :key="index"
        @click.native="bannerClick(item)"
      >
        <img :src="item.imgUrl" />
      </swiper-item>
    </swiper>

    <div class="hasPadding" @touchmove="preLoad(getPre)">
      <list-for-img-and-text :list="list"></list-for-img-and-text>
      <p
        style="text-align:center;margin-top: 1rem"
        v-show="!list.length && !responseEnd"
      >
        <inline-loading></inline-loading>
        <span
          style="vertical-align:middle;display:inline-block;font-size:14px;"
        >
          &nbsp;&nbsp;加载中
        </span>
      </p>
      <p
        style="text-align:center;margin-top: 1rem"
        v-show="!list.length && responseEnd"
      >
        <span
          style="vertical-align:middle;display:inline-block;font-size:14px;"
        >
          &nbsp;&nbsp;暂无数据
        </span>
      </p>
    </div>
  </div>
</template>
<script>
import ListForImgAndText from '@/components/Headline/list.vue';
import { headline } from '@/api/ajax.js';
import { loadMore } from '@/Mixin/loadMore.js';
// TODO: vux
import { Swiper, SwiperItem } from 'vux';
export default {
  name: '',
  mixins: [loadMore],
  data() {
    return {
      params: {
        offset: 0,
        limit: 20
      },
      list: [],
      loadFlag: true,
      responseEnd: false,
      bannerList: null
    };
  },
  methods: {
    bannerClick(item) {
      //小程序中banner 不跳转
      this.$sa.re_click({
        target_name: '暗语banner', // 点击目标名字
        target_contentname: item.title, //点击目标的标题
        target_contentid: '', //点击目标的id
        target_contenturl: item.bannerUrl //点击目标的url
      });

      if (/yxvzb\.com|jimijiayuan\.cn/.test(item.bannerUrl)) {
        this.$sa.setSaSession_href(this.$route, item.bannerUrl);
      } else {
        location.href = item.bannerUrl;
      }
    },
    info() {
      //初始化滑动
      this.courseList = [];
      this.params.offset = 0;
      this.loadFlag = true;
    },
    getList(data) {
      if (this.loadFlag) {
        this.loadFlag = false;
        headline.argotList(data).then(res => {
          this.responseEnd = true;
          for (var i = 0; i < res.data.data.length; i++) {
            this.list.push(res.data.data[i]);
          }
          if (res.data.data.length < 20) {
            this.loadFlag = false;
            return false;
          }
          this.params.offset += this.params.limit;
          this.loadFlag = true;
        });
      }
    },
    getPre() {
      this.getList(this.params);
    }
  },
  computed: {},
  components: {
    ListForImgAndText,
    Swiper,
    SwiperItem
  },
  created() {
    this.getPre();
    if (/isTemp=2/.test(location.href)) {
      //首管消息
      sa.track(
        'first_attention',
        {
          from: 'wx',
          type: 'information',
          web_edition: 2
        },
        function() {}
      );
    }

    headline.watchwordBanner().then(res => {
      this.bannerList = res.data.data;
    });
  }
};
</script>
<style lang="less" scoped>
.swiper-demo-img {
  img {
    max-width: 100%;
    height: 4rem;
  }
}
</style>
